import React from 'react';
import { PlayerType } from '../hooks/usePlayer';
import { StageType } from '../types';
import { checkCollision } from '../gameHelpers';
import { useWindowSize } from '../hooks/useWindowSize';
import Cell from './Cell';

interface GhostTetrominoProps {
  player: PlayerType;
  stage: StageType;
}

const GhostTetromino: React.FC<GhostTetrominoProps> = ({ player, stage }) => {
  const windowSize = useWindowSize();
  // Use the smaller of width-based or height-based cell size
  const cellSize = windowSize.width <= 768 
    ? Math.min(
        (windowSize.width - 20) / 12 - 1,
        (windowSize.height - 150) / 20 - 1
      ) 
    : 30;

  // Calculate drop position
  let dropDistance = 0;
  while (!checkCollision(player, stage, { x: 0, y: dropDistance + 1 })) {
    dropDistance++;
    // Safety check to prevent infinite loops
    if (dropDistance > 30) break;
  }

  return (
    <div className="ghost-tetromino">
      {player.tetromino.map((row, y) =>
        row.map((value, x) => {
          if (value !== 0) {
            const yPos = y + player.pos.y + dropDistance;
            const xPos = x + player.pos.x;

            if (
              yPos >= 0 &&
              yPos < stage.length &&
              xPos >= 0 &&
              xPos < stage[0].length
            ) {
              return (
                <div
                  key={`ghost-${y}-${x}`}
                  style={{
                    position: 'absolute',
                    top: `${yPos * (cellSize + 1)}px`,
                    left: `${xPos * (cellSize + 1)}px`,
                    width: `${cellSize}px`,
                    height: `${cellSize}px`,
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px dashed rgba(255, 255, 255, 0.3)'
                  }}
                />
              );
            }
          }
          return null;
        })
      )}
    </div>
  );
};

export default GhostTetromino;